<template>
  <div class="wanshe">
    <div class="header">
      <img src="https://img.bazhuay.com/1680149345896_154.png" alt="" />
      <div class="tab">
        <ul>
          <li
            v-for="(item, index) in tabList"
            :key="index"
            @click="tabClick(index)"
          >
            {{ item }}
            <span :class="tabActive === index ? 'active' : ''"></span>
          </li>
        </ul>
      </div>
    </div>
    <div class="main main-scroll" @scroll="onScroll">
      <div class="img-box scroll-item">
        <img :src="config.a" alt="" />
      </div>
      <div class="img-box scroll-item">
        <img :src="config.b" alt="" />
      </div>
      <div class="img-box scroll-item">
        <img :src="config.c" alt="" />
      </div>
      <div class="img-box scroll-item">
        <div class="contact_us">
          <img :src="config.d" alt="" />
          <div class="contact_us_carousel">
            <el-carousel :interval="4000" type="card" height="300px">
              <el-carousel-item v-for="item in 5" :key="item">
                <img
                  style="width:100%; height: 100%;"
                  :src="require(`@/assets/images/company_${item}.jpg`)"
                  alt=""
                />
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
      <div class="footer">
        <p>
          <a :href="config.footer.a" target="_blank">营业执照</a>
          <a style="margin-left: 30px;" href="https://beian.miit.gov.cn" target="_blank">{{config.footer.f}}</a>
          <a style="margin-left: 30px;" :href="config.footer.b.url" target="_blank">{{config.footer.b.label}}</a>
        </p>
        <a style="margin-left: 30px;" v-if="config.footer.c.url" :href="config.footer.c.url" target="_blank">{{config.footer.c.label}}</a>
        <a style="margin-left: 30px;" :href="config.footer.d.url" target="_blank">{{config.footer.d.label}}</a>
        <a style="margin-left: 30px;" :href="config.footer.e.url" target="_blank">{{config.footer.e.label}}</a>
        <p>
            <span>联系电话：020-83981884</span>
            <span style="margin-left: 30px;">{{config.footer.g}}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
const webMap= {
  'www.aishezhen.com': {
    title: '正和智能网络科技(广州)有限公司',
    a: 'https://img.bazhuay.com/1681700779212_359.png',
    b: 'https://img.bazhuay.com/1681700871868_652.png',
    c: 'https://img.bazhuay.com/1635905943511_137.jpeg',
    d: 'https://img.bazhuay.com/1640570618256_74.png',
    footer: {
      a: 'https://img.bazhuay.com/1710752612863_586.jpg',
      b: {
        label: '互联网药品信息服务资格证书编号：(粤)-经营性-2022-0021',
        url: 'https://img.bazhuay.com/1708401860573_202.png',
      },
      c: {
        label: '粤穗药监械经营备20240030号',
        url: 'https://img.bazhuay.com/1708401683562_214.png',
      },
      d: {
        label: '药品网络交易服务第三方平台备案凭证： (粤)网药平台备字 (2023) 0037号',
        url: 'https://img.bazhuay.com/1708418020236_939.png',
      },
      e: {
        label: '(粤)网械平台备字(2023) 第00003号',
        url: 'https://img.bazhuay.com/1708401854907_725.png',
      },
      f: '粤ICP备18101403号-4',
      g: '版权所有：正和智能网络科技(广州)有限公司'
    }
  },

  'www.ishezhen.com': {
    title: '正和智连科技有限公司',
    a: 'https://img.bazhuay.com/1681700779212_359.png',
    b: 'https://pic.bazhuay.com/f7a246c32c8d4e10904675e0736164ab.png',
    c: 'https://pic.bazhuay.com/0bd97bfa28284e16ada7fc1acb470aa1.png',
    d: 'https://pic.bazhuay.com/0a8fe2cb2b1f48ebbf0cb502c1c17595.png',
    footer: {
      a: 'https://pic.bazhuay.com/8f13e93b54ba438f9d18507371fb3258.jpg',
      b: {
        label: '互联网药品信息服务资格证书编号：(粤)-经营性-2024-0422',
        url: 'https://img.bazhuay.com/1731297169119_363.pdf',
      },
      c: {
        label: '',
        url: '',
      },
      d: {
        label: '药品网络交易服务第三方平台备案凭证： (粤)网药平台备字 (2024) 0023号',
        url: 'https://img.bazhuay.com/1731297077808_327.pdf',
      },
      e: {
        label: '(粤)网械平台备字(2024) 第00042号',
        url: 'https://img.bazhuay.com/1731296996338_3.pdf',
      },

      f: '粤ICP备2023135564号-4',
      g: '版权所有：正和智连科技有限公司'
    }
  }
}



export default {
  name: "Wanshe",
  data() {
    return {
      config: {},
      tabList: ["关于我们", "产品介绍", "公司简介", "联系我们"],
      tabActive: 0,
      scrollLock: false, // 当触发点击的时候 不监听滚动事件
      // icp: "",
    };
  },

  created() {
    this.config = webMap[window.location.host] || webMap['www.ishezhen.com'];
    document.title = this.config.title;
    // this.icp = icpMap.find((item) => window.location.host.includes(item.web))?.icp || '';
  },

  methods: {
    /**
     * tab点击事件
     */
    tabClick(index) {
      this.scrollLock = true;
      let target = document.querySelector(".main-scroll");
      let scrollItems = document.querySelectorAll(".scroll-item");
      this.tabActive = index;
      let total = scrollItems[index].offsetTop - scrollItems[0].offsetTop; // 锚点元素距离其offsetParent(这里是body)顶部的距离(待滚动的距离)
      let distance = document.querySelector(".main-scroll").scrollTop; // 滚动条距离滚动区域顶部的距离
      let step = total / 25;
      if (total > distance) {
        smoothDown(target);
        this.scrollLock = false;
      } else {
        const newTotal = distance - total;
        step = newTotal / 25;
        smoothUp(target);
        this.scrollLock = false;
      }

      function smoothDown(el) {
        if (distance < total) {
          distance += step;
          el.scrollTop = distance;
          setTimeout(smoothDown.bind(this, el), 10);
        } else {
          el.scrollTop = total;
        }
      }

      function smoothUp(el) {
        if (distance > total) {
          distance -= step;
          el.scrollTop = distance;
          setTimeout(smoothUp.bind(this, el), 10);
        } else {
          el.scrollTop = total;
        }
      }
    },

    /**
     * onScroll监听滚动事件
     */
    onScroll(e) {
      if (this.scrollLock) return;
      let scrollItems = document.querySelectorAll(".scroll-item");
      for (let i = scrollItems.length - 1; i >= 0; i--) {
        // 判断滚动条滚动距离是否大于当前滚动项可滚动距离
        let judge =
          e.target.scrollTop >=
          scrollItems[i].offsetTop - scrollItems[0].offsetTop;
        if (judge) {
          this.tabActive = i;
          break;
        }
      }

      let target = document.querySelector(".main-scroll");
      // 滚动到底部
      if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
        if (this.tabActive !== this.tabList.length - 1) {
          this.tabActive = this.tabList.length - 1;
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  margin: 0;
  text-align: center;
}
.el-carousel__item {
  background-color: pink;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>

<style scoped lang="less">
.wanshe {
  position: relative;
  width: 100%;
  height: 100%;
  padding-top: 77px;
  box-sizing: border-box;
  .header {
    position: fixed;
    top: 0;
    width: 100%;
    height: 77px;
    .tab {
      position: absolute;
      top: 0;
      right: 206px;
      height: 100%;
      ul {
        width: 100%;
        height: 100%;
        display: flex;
        padding: 0;
        margin: 0;
        list-style: none;
        li {
          padding: 0;
          margin: 0;
          list-style: none;
          width: 100px;
          height: 100%;
          text-align: center;
          line-height: 77px;
          position: relative;
          font-size: 16px;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.85);
          .active {
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 20px;
            height: 5px;
            background: #6599ff;
          }
        }
      }
    }
    img {
      width: 100%;
    }
  }
  .main {
    width: 100%;
    height: 100%;
    overflow: auto;
    .img-box {
      width: 100%;
      img {
        width: 100%;
      }
      .contact_us {
        position: relative;
        width: 100%;
        .contact_us_carousel {
          position: absolute;
          right: 150px;
          top: 50%;
          transform: translateY(-50%);
          width: 800px;
        }
      }
    }
    .footer {
      width: 100%;
      text-align: center;
      background: #1d2639;
      p {
        padding: 10px;
      }
      a {
        color: #7C7E7E;
        font-size: 16px;
        &:hover {
          color: #fff;
          cursor: pointer;
        }
      }
    }
  }
  .main::-webkit-scrollbar {
    display: none;
  }
}
</style>
